import s from './index.module.scss';

export const DashboardBonusCard = ({ title, text, icon, footer, modal }) => {
  return (
    <div className={s.card}>
      <div className={s.content}>
        <div className={s.header}>
          <div className={s.title}>{title}</div>
          {icon}
        </div>
        <div className={s.desc}>{text}</div>
      </div>
      <div className={s.footer}>{footer}</div>
      {modal}
    </div>
  );
};
